export type GlobalConfigConfirmationType = GlobalConfigConfirmationTypes.SOLO | GlobalConfigConfirmationTypes.CASCADE;

export enum GlobalConfigConfirmationTypes {
  /** The global config setting is saved only on the global level */
  SOLO = 'Solo',
  /** The global config setting will cascade down and apply on columns and key metrics */
  CASCADE = 'Cascade',
}
